<template lang="pug">
  .wrap.agb
    #content
      .content
        .wrap
          .block(v-html="content")
 </template>

<script>
import { getPage as apiGetPage } from '@/api'
export default {
  name: 'AGB',
  metaInfo () {
    return {
      title: 'Allgemeine Geschäftsbedingungen',
      meta: [
        { hid: 'description', name: 'description', content: `` }
      ]
    }
  },
  data: () => ({
    content: ``
  }),
  methods: {
  },
  async created() {

    // get page data from https://backend.kstarberlin.de/wp-json/wp/v2/pages/74887
    try {
      const { content: { rendered } } = await apiGetPage({ id: 74887 })
      console.log(rendered)
      this.content = rendered
    } catch(err) {

    }
  
  },
  mounted () {
    window._paq.push(['setCustomUrl', window.location])
    window._paq.push(['setDocumentTitle', this.$metaInfo.title])
    window._paq.push(['trackPageView'])
  }
}
</script>

<style lang="sass">
.agb
  .action
    cursor: pointer
  .block
    max-width: 600px
    margin: 0 auto
  .content
    padding: 20px 0
    border-bottom: 1px dashed #aaa
    &:last-child
      border-bottom: 0

  .block
    p, li
      line-height: 1.4em
    p, div
      margin-bottom: 1em
      &:last-child
        margin-bottom: 0
    ul, ol
      margin-bottom: 1em
    li
      margin-bottom: .5em
    a
      color: #c00
    h1, h2, h3, h4, h5
      margin-bottom: .5em
    .center
      text-align: center
</style>
